export default {
  Reports: {
    _tag: 'CSidebarNavItem',
    name: 'Reports',
    phrase: 'nav-reports',
    to: '/reports',
    order: 5,
    icon: 'fa-regular fa-file-lines',
   roles: ['Admin','Sub Admin'],
  },
}
